
import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "VJoinUs",
  props: {
    src: String
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN"
    }),
    ...mapState("assets", {
      url: "url"
    })
  }
});
